import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const P_DEVISE_SCHEMA_LITERAL = {
    title: 'Schéma Devise',
    description: 'Décrit une devise',
    version: 0,
    keyCompression: false,
    primaryKey: 'CBINDICE',
    type: 'object',
    properties: {
        CBINDICE: { type: 'string', maxLength : 2 },
        D_MAIN: { type: 'number' },
        D_INTITULE: { type: 'string' },
        D_MONNAIE: { type: 'string' },
        D_FORMAT: { type: 'string' },
        D_COURS: { type: 'number' },
        D_CODEISO: { type: 'string' },
        D_SIGLE: { type: 'string' } 
    },
    required: [ 'CBINDICE', 'D_INTITULE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(P_DEVISE_SCHEMA_LITERAL);
export type RxPDeviseDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const P_DEVISE_SCHEMA: RxJsonSchema<RxPDeviseDocumentType> = P_DEVISE_SCHEMA_LITERAL;
